/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import { Children, cloneElement, createRef, useEffect, useRef, useState } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import styles from "./index.module.scss";

const Preview = ({ settings, children, ...props }) => {
  const sliderRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // sliderRef.current.slickGoTo(currentIndex);
  }, [currentIndex]);
  return (
    <>
      <div className="relative w-full">
        <Slider
          ref={sliderRef}
          waitForAnimate={false}
          className={styles["g-slider-preview"]}
          dotsClass={styles["slick-dots-preview"]}
          beforeChange={(current, next) => {
            setCurrentIndex(Math.ceil(next));
          }}
          appendDots={(dots) => (
            <div>
              <ul className="flex items-center justify-center"> {dots} </ul>
            </div>
          )}
          customPaging={(i) => (
            <span
              className={Math.ceil(i) === currentIndex ? "slick-active" : ""}
            >
              <button>{i + 1}</button>
            </span>
          )}
          {...settings}
        >
          {children &&
            Children.count(children) > 0 &&
            Children.map(children, (element, idx) => {
              return (
                <>
                  {cloneElement(element, {
                    ref: createRef(idx),
                    className: `mx-auto ${!settings.adaptiveHeight && "h-full"
                      }`,
                  })}
                </>
              );
            })}
        </Slider>
      </div>
    </>
  );
};

Preview.propTypes = {
  settings: PropTypes.object,
  children: PropTypes.any,
};

Preview.defaultProps = {
  settings: {},
  children: <></>,
};

export default Preview;
